import React, { FC, useCallback, useContext } from 'react';
import { css } from '@emotion/css';

import { Device, DrainContext, FilterCurrent } from 'contexts/DrainContext';
import { FilterTaxonomy, getFilterTaxonomyOptions } from 'api/queries/filter';
import SelectFilter from 'components/selectFilter/SelectFilter';
import { EMPTY_ELEMENT } from 'common/utils/react';

const Styles = {
  container: css`
    flex: 1;

    .select-filter {
      margin-right: 12px;

      &:last-child {
        margin-right: 0;
      }
    }
  `,
  item: (list: FilterTaxonomy) => {
    const count = Object.values(list).length;
    return css`
      flex-basis: 100%;
    `;
  },
  audience: css`
    flex-basis: 20%;
  `,
  other: css`
    flex-basis: 26%;
  `,
  from: css`
    flex-basis: 28%;
  `,
};

interface Props {
  filterList?: FilterTaxonomy;
  className: string;
}

const FilterGroupDesktop: FC<Props> = ({ filterList, className }) => {
  const drain = useContext(DrainContext);

  const applyCallback = useCallback(
    (filter: FilterCurrent) => {
      drain.switchFilter({
        apply: true,
        device: Device.Desktop,
        sorting: {
          current: drain.sort,
          previous: drain.prevSort,
        },
        currentFilter: filter,
      });
      drain.trackDrainFilterSection(filter, drain.search);
    },
    [drain.apply, drain.filter, drain.search, drain.sort]
  );

  return (
    <div className={`${className} ${Styles.container}`}>
      {filterList
        ? Object.keys(filterList.elements)
            .filter(taxonomyCode => filterList.elements[taxonomyCode].switched)
            .map((taxonomyCode: string, idx: number, codes: string[]) => {
              const taxonomy: typeof filterList.elements[keyof typeof filterList.elements] =
                filterList.elements[taxonomyCode];
              const isSearchBar = taxonomyCode === 'location';

              return (
                <SelectFilter
                  key={idx}
                  filterOptions={getFilterTaxonomyOptions(filterList)}
                  className={Styles.item(filterList)}
                  title={taxonomy.question}
                  parentCodename={taxonomyCode}
                  items={taxonomy.terms}
                  applyCallback={applyCallback}
                  searchLabel={filterList.filter.options[taxonomyCode].search.title}
                  popupRight={idx === codes.length - 1}
                  isSearchBar={isSearchBar}
                />
              );
            })
        : EMPTY_ELEMENT}
    </div>
  );
};

export default FilterGroupDesktop;
